import React from 'react';
import { motion } from 'framer-motion';
import { CloudRain, Zap } from 'lucide-react';
export function TrianguloNoche() {
  return <section className="py-24 px-6 bg-[var(--bg-surface)] relative overflow-hidden" data-id="element-359">
      {/* Subtle background glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[var(--accent)] opacity-5 blur-[120px] rounded-full pointer-events-none" data-id="element-360" />

      <div className="max-w-[720px] mx-auto relative z-10" data-id="element-361">
        <div className="text-center mb-16" data-id="element-362">
          <p className="text-[var(--accent)] text-xs font-bold tracking-widest uppercase mb-4" data-id="element-363">
            El Mecanismo de Sanación
          </p>
          <h2 className="text-3xl md:text-4xl font-serif text-[var(--text-heading)] mb-6" data-id="element-364">
            La fe no se recupera con un impacto. <br data-id="element-365" />
            <span className="text-[var(--text-muted)] italic" data-id="element-366">
              Se recupera por goteo.
            </span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 items-center mb-12" data-id="element-367">
          <div className="bg-[var(--bg-elevated)] p-8 rounded-lg border border-[var(--bg-surface)] opacity-60" data-id="element-368">
            <div className="flex items-center gap-3 mb-4 text-[var(--text-muted)]" data-id="element-369">
              <Zap className="w-5 h-5" data-id="element-370" />
              <h3 className="font-bold uppercase tracking-wide text-sm" data-id="element-371">
                El Relámpago
              </h3>
            </div>
            <p className="text-sm leading-relaxed" data-id="element-372">
              Los grandes momentos espirituales son hermosos, pero raros.
              Esperar un "milagro instantáneo" a menudo nos deja vacíos cuando
              no llega el lunes por la mañana.
            </p>
          </div>

          <div className="bg-[var(--bg-elevated)] p-8 rounded-lg border border-[var(--accent)]/30 shadow-[0_0_30px_rgba(0,0,0,0.2)] relative overflow-hidden" data-id="element-373">
            <div className="absolute top-0 left-0 w-1 h-full bg-[var(--accent)]" data-id="element-374"></div>
            <div className="flex items-center gap-3 mb-4 text-[var(--accent)]" data-id="element-375">
              <CloudRain className="w-5 h-5" data-id="element-376" />
              <h3 className="font-bold uppercase tracking-wide text-sm" data-id="element-377">
                La Lluvia Suave
              </h3>
            </div>
            <p className="text-[var(--text-primary)] text-sm leading-relaxed font-medium" data-id="element-378">
              Lo que realmente sana el alma es la lluvia suave que cae 40
              mañanas seguidas. Pequeñas dosis de verdad que empapan la tierra
              seca de tu corazón.
            </p>
          </div>
        </div>

        <div className="text-center space-y-6" data-id="element-379">
          <h3 className="text-2xl font-serif text-[var(--text-heading)]" data-id="element-380">
            El Micro-Encuentro de 40 Días
          </h3>
          <p className="text-lg text-[var(--text-muted)] max-w-xl mx-auto" data-id="element-381">
            No necesitas horas de oración. No necesitas sentirte bien para
            empezar. Solo necesitas{' '}
            <span className="text-[var(--accent)] font-bold" data-id="element-382">
              5 minutos cada mañana
            </span>
            .
          </p>
          <p className="text-[var(--text-primary)] italic font-serif text-xl" data-id="element-383">
            "Así es como el corazón roto vuelve a latir: despacio, en silencio,
            sin prisa y sin presión."
          </p>
        </div>
      </div>
    </section>;
}